const money = (value) => {
  // return parseInt(+value / 1000)
  return +value / 100
}

const filter = {
  install(vue) {
    vue.filter('money', money)

    vue.mixin({
      methods: {
        money,
      },
    })
  },
}

export default filter



// WEBPACK FOOTER //
// ./src/plugins/filter.js